import { Width } from '../xlsxExport.constants';
import exportFormatsToCustomFormats from './exportFormatsToCustomFormats';

const getWidthMultiplier = (isDescriptionColumn, exportWidthMultiplier, customExportWidthMultiplier) => {
  // Prefer new customExport format, fallback to legacy property
  const widthMultiplier = customExportWidthMultiplier ?? exportWidthMultiplier;

  if (widthMultiplier || widthMultiplier === 0) {
    return widthMultiplier;
  }
  return isDescriptionColumn
    ? Width.firstColumnMultiplier
    : Width.multiplier;
};

const columnDefsToColumnStyle = (columnDefinitions, descriptionColumnIndex = 0, options = {}) => {
  const {
    hideDecimals,
    negativeMinus,
    shouldDisplayZero,
  } = options;

  return columnDefinitions.map((columnDef, index) => {
    // Support both new customExport format and legacy direct properties
    const exportFormat = columnDef.customExport?.format || columnDef.exportFormat;
    const exportWidthMultiplier = columnDef.exportWidthMultiplier;
    const customExportWidthMultiplier = columnDef.customExport?.widthMultiplier;

    const { cellStyle } = columnDef;
    const widthMultiplier = getWidthMultiplier(index === descriptionColumnIndex,
      exportWidthMultiplier, customExportWidthMultiplier);

    const columnStyle = {};

    const width = columnDef.width || columnDef.minWidth || 120;
    columnStyle.width = width * widthMultiplier;

    if (exportFormat) {
      columnStyle.numFmt = exportFormatsToCustomFormats(
        exportFormat,
        {
          hideDecimals,
          negativeMinus,
          shouldDisplayZero,
        }
      );
    }

    if (columnDef.hide) {
      columnStyle.hidden = true;
    }

    if (!cellStyle) {
      return columnStyle;
    }

    const textAlignCellStyle = cellStyle['text-align'];

    if (textAlignCellStyle) {
      columnStyle.alignment = {
        horizontal: textAlignCellStyle,
      };
    }

    return columnStyle;
  });
};
export default columnDefsToColumnStyle;
